import { useEffect, useState } from "react";

const useOnScreen = (ref) => {
  const [isVisible, setIsVisible] = useState(false);
  const [hasTriggered, setHasTriggered] = useState(false); // Trạng thái đánh dấu đã set

  useEffect(() => {
    if (hasTriggered) return; // Nếu đã set thì không làm gì nữa

    const handleScroll = () => {
      if (!ref.current) return;

      const rect = ref.current.getBoundingClientRect();
      const screenHeight = window.innerHeight;

      // Kiểm tra nếu vị trí top của phần tử cách đáy màn hình 30% chiều cao màn hình
      if (rect.top <= screenHeight * 0.9) {
        setIsVisible(true);
        setHasTriggered(true); // Đánh dấu đã set
        window.removeEventListener("scroll", handleScroll); // Ngừng lắng nghe
      }
    };

    // Lắng nghe sự kiện scroll
    window.addEventListener("scroll", handleScroll);

    // Gọi handleScroll ngay khi component mount để kiểm tra ban đầu
    handleScroll();

    return () => window.removeEventListener("scroll", handleScroll);
  }, [ref, hasTriggered]);

  return isVisible;
};

export default useOnScreen;
